/*
 * @Descripttion: 隐私政策
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-21 10:00:44
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2022-07-21 10:08:40
 */

const privacyPolicy = {
  title: '隐私政策',
  list: [
    { title: '承诺', des: ['脉流科技致力于保护您在使用本网站时所提供的私人信息及资料，使私人信息及资料的收集、使用、储存和传送方面符合有关的法律法规相关标准。', '请您务必要仔细阅读及理解本隐私声明。您一旦使用本网站，将被视为接受、同意、承诺和确认本隐私声明所涉及的内容'] },
    { title: '个人信息', des: ['您在匿名的状态下即可访问本网站并获取信息。为了更好的了解您的需求，为您提供更为优质的服务，请理解有些信息或服务需要您注册后才能向您提供。需要收集的个人信息包括您的姓名、地址、电话号码或者电子邮件地址等，以下统称为｢个人信息｣。', '您如希望使用本网站需注册后才能够提供的服务，应同意以下事项∶依本服务注册表之提示提供您本人真实、正确、最新及完整的资料，并及时更新登记资料。若您提供任何错误、不实、过时、不完整或具误导性的资料，或者本网站有理由怀疑前述资料为错误、不实、过时、不完整或具误导性的，本网站有权暂停或终止您的帐户，并拒绝您使用本网站所提供之全部或任何部分服务。'] },
    { title: '使用目的', des: ['对于您提供的个人信息的使用目的，原则上限定在脉流科技事先公开的使用目的范围内。如果我们欲将您的个人信息用于已公开的指定目的范围之外，则会预先通知您新的使用目的。如果您不同意把个人资料用于新的使用目的，您可根据自己的判断拒绝。'] },
    { title: '使用目的的限制', des: ['本网站将采取合理的安全手段保护您已存储的个人信息，在未得到您许可之前，除非根据法律或政府的强制性规定，脉流科技不会将通过本网站搜集的关于您的任何个人信息提供给任何无关的第三方（包括公司和个人）。', '您应了解：本网站可能会应法律之要求或者因善意确信这样的作法对于下列各项有其必要性，而公开个人资料：', '<ul><li class="before_diamond ui-core_strengths-list"><p>01. 为符合法律公告或遵守适用于脉流科技公司的合法程序；</p></li><li class="before_diamond ui-core_strengths-list"><p>02. 保护本网站用户的权利和财产；</p></li><li class="before_diamond ui-core_strengths-list"><p>03. 在紧急的情况下，为了保护本网站及其用户之安全。</p></li></ul>'] },
    { title: '非个人信息', des: ['本网站将通过用户的 IP 地址来收集非个人信息，例如浏览器和操作系统的种类、提供接入服务的 ISP 名称等，以优化在您计算机屏幕上显示的界面；并通过收集上述信息，进行访客流量统计。这些无关个人身份的信息能帮助本站辨别内容喜好的地区性分布，保证本站进行推广活动的有效性并帮助我们改善其性能和内容。'] },
    { title: '链接到其他站点', des: ['为了方便您的使用，本网站为您提供了其他网站的链接。这些网站可能会有隐私声明，为了您的利益考虑，我们建议您浏览这些网页前先阅读其隐私声明，脉流科技将不对这些链接网站的内容以及运行负责。'] },
    { title: '未成年人的隐私保护', des: ['脉流科技十分关心所有用户的安全和隐私，特别是未成年人用户。在未按照法律的规定征得未成年人监护人的同意时，本网站不会有意收集未成年人的个人信息。仅在法律范围内征得未成年人监护人的同意后收集未成年人信息。脉流科技将建立和维持完善合理的程序，以保障未成年人个人信息的保密性和安全性。'] },
    { title: '隐私声明的变更', des: ['本网站可能对本隐私声明定期进行修改。如果进行任何修改，本网站将在首页的公告栏上 通知以使用户知道被修改内容的类型以及指示用户审阅更新的隐私政策。如果在本隐私声明任何修改发布后，您继续使用本网站，则表示您同意遵守任何该等修改'] }
  ],
  bottom: [
    '如果您有任何疑问，或者有任何建议，请通过以下方式联系我们：',
    '杭州总部:浙江省杭州市滨江区阡陌路459号 聚光中心C1-501。',
    'TEL: +86(571)- 86772567',
    'Copyright©杭州脉流科技有限公司'
  ],
  time: '最近更新：2022年1月1日'
}

export default privacyPolicy
